import { render, staticRenderFns } from "./NewsSociety.vue?vue&type=template&id=733b7ae0&scoped=true&"
import script from "./NewsSociety.vue?vue&type=script&lang=js&"
export * from "./NewsSociety.vue?vue&type=script&lang=js&"
import style0 from "./NewsSociety.vue?vue&type=style&index=0&id=733b7ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733b7ae0",
  null
  
)

export default component.exports